<template>
    
    <div class="w-full h-auto flex flex-col" > 

        <label class="text-sm block tracking-widest py-2" v-if="label" >{{ label + ( required ? '*' : '' ) }}</label>

        <textarea 
        
        class=" text-sm 
                w-full
                h-32
                border 
                border-solid 
                border-gray-400
                rounded-md 
                p-4 
                outline-none
                focus:border-ch-blue"

        :placeholder="placeholder"

        v-model="input"
        
        />

    </div>

</template>

<script>

    import { ref, computed } from 'vue'

    export default {
    
        name: 'Input',

        props: {

            label: String,
            validate: Boolean,
            disabled: Boolean,
            modelValue: String,
            placeholder: String,
            required: { type: Boolean, default: true },

        },
        
        setup( props, { emit } ) {

            const input = computed({
                get: () => props.modelValue,
                set: val => emit( 'update:modelValue', val )
            })
            
            return {
                input
            }

        }

    }

</script>
